import {
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import React, { useEffect } from 'react';

const WondrMobileAppModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Auto-open the modal when component mounts
  useEffect(() => {
    onOpen();
  }, [onOpen]);

  const handleCompleted = () => {
    onClose();
  };

  return (
    <SessionReminderModal
      popupId="wondr-app-reminder"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent bg="bg.default" color="text.default">
        <ModalHeader>📱 Wondr Mobile App Reminder</ModalHeader>

        <ModalBody>
          <VStack spacing={4} align="start">
            <Text>
              <strong>Reminder for your patient:</strong>
            </Text>

            <VStack as="ul" spacing={3} align="start" w="full" pl={4}>
              <Text as="li">
                Remind patients to use the Wondr app for food and goal logging.
              </Text>
              <Text as="li">
                Encourage patients to enter their MNT goals into the self-led
                program within the Wondr app.
              </Text>
              <Text as="li">
                Encourage patients to screen share their food logs in session.
              </Text>
            </VStack>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={2} w="full">
            <Button colorScheme="blue" onClick={handleCompleted} w="full">
              Got it!
            </Button>
          </VStack>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default WondrMobileAppModal;
